import './winmock11/style';
import FormStructure from './winmock11/form_structure';

export default FormStructure;